import type { ReactNode } from "react";

interface Props {
  index?: string;
  eyebrow?: string;
  title: ReactNode;
  desc?: ReactNode;
  right?: ReactNode;
  tone?: "light" | "dark";
}

export default function SectionHeading({ index, eyebrow, title, desc, right, tone = "light" }: Props) {
  const isDark = tone === "dark";
  return (
    <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-3">
          {index && (
            <span
              className={`grid h-10 w-10 shrink-0 place-items-center rounded-md font-heading text-lg font-black ${
                isDark ? "bg-accent-500 text-background-950" : "bg-primary-500 text-background-50"
              }`}
            >
              {index}
            </span>
          )}
          <div>
            {eyebrow && (
              <p className={`text-xs uppercase tracking-[0.28em] ${isDark ? "text-accent-300" : "text-primary-600"}`}>
                {eyebrow}
              </p>
            )}
            <h2 className={`mt-1 font-heading text-2xl font-black tracking-tight md:text-3xl ${isDark ? "text-background-50" : "text-foreground-950"}`}>
              {title}
            </h2>
          </div>
        </div>
        {desc && (
          <p className={`mt-4 pl-0 text-sm leading-relaxed md:pl-[52px] ${isDark ? "text-background-200/80" : "text-foreground-600"}`}>
            {desc}
          </p>
        )}
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}